import axios from "@/helpers/axios";
const commonURL = "/config";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  getters: {},
  actions: {
    async getOrderConfig() {
      try {
        const result = await axios({
          method: "GET",
          url: `${commonURL}`,
        });
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },

    async getVehicles() {
      try {
        const result = await axios({
          method: "get",
          url: `${commonURL}/vehicles`,
        });
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
  },
};
